module.exports = __webpack_public_path__ + "static/img/public2.5e4db20.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/common/public2.png
// module id = BjG8
// module chunks = 22